import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import BatchUpdatesDrawer from '@/pages/batchUpdatesAdmin/BatchUpdatesAdminDrawer.component'
import { createBatchUpdatesByIdOptionsQuery } from '@/services/batchUpdate/batchUpdates.options'
// import { createStatusesQueryOptions } from '@/hooks/fetches/useTicket.service'
import { createCustomerOptionsQuery } from '@/services/customer/customer.options'
import { createStatusesQueryOptions } from '@/services/ticket/ticket.options'
import { createAllUsersQueryOptions } from '@/services/users/userProfile.options'
import { createTicketTypesQueryOptions } from '@/services/type/type.options'

export const Route = createFileRoute('/_auth/batch-updates/$batchUpdateId')({
  component: () => <BatchUpdatesDrawer />,
  params: {
    parse: (params) => ({
      batchUpdateId: z.number().int().parse(Number(params.batchUpdateId)),
    }),
    stringify: ({ batchUpdateId }) => ({ batchUpdateId: `${batchUpdateId}` }),
  },
  validateSearch: (search) => {
    return z
      .object({
        variant: z.enum(['edit', 'new']).default('edit'),
      })
      .parse(search)
  },
  loader: async ({ params, context }) => {
    const { batchUpdateId } = params
    // const batchUpdate = await context.queryClient.ensureQueryData(createBatchUpdatesByIdOptionsQuery(batchUpdateId))
    context.queryClient.ensureQueryData(createStatusesQueryOptions())
    context.queryClient.ensureQueryData(createCustomerOptionsQuery())
    context.queryClient.ensureQueryData(createTicketTypesQueryOptions())
    context.queryClient.ensureQueryData(createAllUsersQueryOptions())
    if (batchUpdateId === 0) return
    context.queryClient.ensureQueryData(createBatchUpdatesByIdOptionsQuery(batchUpdateId))
    // return { batchUpdate }
  }
})
